(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouma-supplements"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
const trigger = event.target.closest('[data-product-dialog]');
if (trigger) document.getElementById(trigger.dataset.productDialog).showModal();
const close = event.target.closest('[data-close-product]');
if (close) close.closest('dialog').close();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouma-whey"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-whey-zoom]');
  if (trigger) {
    const dialog = trigger.closest('.whey-page').querySelector('.whey-lightbox');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    const image = dialog.querySelector('.whey-lightbox-image');
    image.src = trigger.href;
    image.alt = trigger.querySelector('img').alt;
    dialog.showModal();
    return;
  }
  const close = event.target.closest('.whey-lightbox-close');
  if (close) { close.closest('dialog').close(); return; }
  if (event.target.matches('.whey-lightbox')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});

  } catch(e) { console.error(e); }
})();
})();
